module.exports = __webpack_public_path__ + "static/media/Opioid-M-One-10D-NEW.d9bc687c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Opioid-M-One-10D-NEW.mp3
// module id = 594
// module chunks = 0